// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/component/shielded_pool/v1/shielded_pool.proto (package penumbra.core.component.shielded_pool.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Amount } from "../../../num/v1/num_pb.js";
import { Address, AddressView, PayloadKey } from "../../../keys/v1/keys_pb.js";
import { AssetId, BalanceCommitment, Metadata, Value, ValueView } from "../../../asset/v1/asset_pb.js";
import { StateCommitment } from "../../../../crypto/tct/v1/tct_pb.js";
import { SpendAuthSignature, SpendVerificationKey } from "../../../../crypto/decaf377_rdsa/v1/decaf377_rdsa_pb.js";
import { Nullifier } from "../../sct/v1/sct_pb.js";
import { Clue } from "../../../../crypto/decaf377_fmd/v1/decaf377_fmd_pb.js";
import { TransactionId } from "../../../txhash/v1/txhash_pb.js";
/**
 * Configuration data for the shielded pool component.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.ShieldedPoolParameters
 */
export class ShieldedPoolParameters extends Message {
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.FmdParameters fixed_fmd_params = 1 [deprecated = true];
     * @deprecated
     */
    fixedFmdParams;
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.FmdMetaParameters fmd_meta_params = 2;
     */
    fmdMetaParams;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.ShieldedPoolParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "fixed_fmd_params", kind: "message", T: FmdParameters },
        { no: 2, name: "fmd_meta_params", kind: "message", T: FmdMetaParameters },
    ]);
    static fromBinary(bytes, options) {
        return new ShieldedPoolParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShieldedPoolParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShieldedPoolParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShieldedPoolParameters, a, b);
    }
}
/**
 * Genesis data for the shielded pool component.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.GenesisContent
 */
export class GenesisContent extends Message {
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.ShieldedPoolParameters shielded_pool_params = 1;
     */
    shieldedPoolParams;
    /**
     * The allocations present at genesis
     *
     * @generated from field: repeated penumbra.core.component.shielded_pool.v1.GenesisContent.Allocation allocations = 3;
     */
    allocations = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.GenesisContent";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "shielded_pool_params", kind: "message", T: ShieldedPoolParameters },
        { no: 3, name: "allocations", kind: "message", T: GenesisContent_Allocation, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.GenesisContent.Allocation
 */
export class GenesisContent_Allocation extends Message {
    /**
     * @generated from field: penumbra.core.num.v1.Amount amount = 1;
     */
    amount;
    /**
     * @generated from field: string denom = 2;
     */
    denom = "";
    /**
     * @generated from field: penumbra.core.keys.v1.Address address = 3;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.GenesisContent.Allocation";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "amount", kind: "message", T: Amount },
        { no: 2, name: "denom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent_Allocation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent_Allocation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent_Allocation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent_Allocation, a, b);
    }
}
/**
 * The parameters which control how the FMD parameters evolve over time.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParameters
 */
export class FmdMetaParameters extends Message {
    /**
     * How much time users have to transition to new parameters.
     *
     * @generated from field: uint64 fmd_grace_period_blocks = 1;
     */
    fmdGracePeriodBlocks = protoInt64.zero;
    /**
     * The algorithm governing how the parameters change.
     *
     * @generated from oneof penumbra.core.component.shielded_pool.v1.FmdMetaParameters.algorithm
     */
    algorithm = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.FmdMetaParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "fmd_grace_period_blocks", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "fixed_precision_bits", kind: "scalar", T: 13 /* ScalarType.UINT32 */, oneof: "algorithm" },
        { no: 3, name: "sliding_window", kind: "message", T: FmdMetaParameters_AlgorithmSlidingWindow, oneof: "algorithm" },
    ]);
    static fromBinary(bytes, options) {
        return new FmdMetaParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FmdMetaParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FmdMetaParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FmdMetaParameters, a, b);
    }
}
/**
 * A sliding window algorithm for updating the parameters.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParameters.AlgorithmSlidingWindow
 */
export class FmdMetaParameters_AlgorithmSlidingWindow extends Message {
    /**
     * The window size, in terms of the number of update periods.
     *
     * The update period is 16 blocks, by default, but can change with governance.
     *
     * @generated from field: uint32 window_update_periods = 1;
     */
    windowUpdatePeriods = 0;
    /**
     * The number of detections we aim to see per window.
     *
     * @generated from field: uint32 targeted_detections_per_window = 2;
     */
    targetedDetectionsPerWindow = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.FmdMetaParameters.AlgorithmSlidingWindow";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "window_update_periods", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
        { no: 2, name: "targeted_detections_per_window", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);
    static fromBinary(bytes, options) {
        return new FmdMetaParameters_AlgorithmSlidingWindow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FmdMetaParameters_AlgorithmSlidingWindow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FmdMetaParameters_AlgorithmSlidingWindow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FmdMetaParameters_AlgorithmSlidingWindow, a, b);
    }
}
/**
 * Used to potentially store state for the FMD Meta Parameters algorithm.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState
 */
export class FmdMetaParametersAlgorithmState extends Message {
    /**
     * @generated from oneof penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState.state
     */
    state = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "fixed", kind: "message", T: FmdMetaParametersAlgorithmState_FixedState, oneof: "state" },
        { no: 2, name: "sliding_window", kind: "message", T: FmdMetaParametersAlgorithmState_SlidingWindowState, oneof: "state" },
    ]);
    static fromBinary(bytes, options) {
        return new FmdMetaParametersAlgorithmState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FmdMetaParametersAlgorithmState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FmdMetaParametersAlgorithmState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FmdMetaParametersAlgorithmState, a, b);
    }
}
/**
 * The state used for the fixed algorithm.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState.FixedState
 */
export class FmdMetaParametersAlgorithmState_FixedState extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState.FixedState";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new FmdMetaParametersAlgorithmState_FixedState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FmdMetaParametersAlgorithmState_FixedState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FmdMetaParametersAlgorithmState_FixedState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FmdMetaParametersAlgorithmState_FixedState, a, b);
    }
}
/**
 * The state used for the sliding window algorithm.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState.SlidingWindowState
 */
export class FmdMetaParametersAlgorithmState_SlidingWindowState extends Message {
    /**
     * The number of clues previously observed, approximately.
     *
     * @generated from field: uint32 approximate_clue_count = 1;
     */
    approximateClueCount = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.FmdMetaParametersAlgorithmState.SlidingWindowState";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "approximate_clue_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);
    static fromBinary(bytes, options) {
        return new FmdMetaParametersAlgorithmState_SlidingWindowState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FmdMetaParametersAlgorithmState_SlidingWindowState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FmdMetaParametersAlgorithmState_SlidingWindowState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FmdMetaParametersAlgorithmState_SlidingWindowState, a, b);
    }
}
/**
 * Parameters for Fuzzy Message Detection
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.FmdParameters
 */
export class FmdParameters extends Message {
    /**
     * @generated from field: uint32 precision_bits = 1;
     */
    precisionBits = 0;
    /**
     * @generated from field: uint64 as_of_block_height = 2;
     */
    asOfBlockHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.FmdParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "precision_bits", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
        { no: 2, name: "as_of_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new FmdParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FmdParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FmdParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FmdParameters, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.Note
 */
export class Note extends Message {
    /**
     * @generated from field: penumbra.core.asset.v1.Value value = 1;
     */
    value;
    /**
     * @generated from field: bytes rseed = 2;
     */
    rseed = new Uint8Array(0);
    /**
     * @generated from field: penumbra.core.keys.v1.Address address = 3;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.Note";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "message", T: Value },
        { no: 2, name: "rseed", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new Note().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Note().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Note().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Note, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.NoteView
 */
export class NoteView extends Message {
    /**
     * @generated from field: penumbra.core.asset.v1.ValueView value = 1;
     */
    value;
    /**
     * @generated from field: bytes rseed = 2;
     */
    rseed = new Uint8Array(0);
    /**
     * @generated from field: penumbra.core.keys.v1.AddressView address = 3;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.NoteView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "message", T: ValueView },
        { no: 2, name: "rseed", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "address", kind: "message", T: AddressView },
    ]);
    static fromBinary(bytes, options) {
        return new NoteView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoteView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoteView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoteView, a, b);
    }
}
/**
 * An encrypted note.
 * 176 = 80(address) + 16(amount) + 32(asset ID) + 32(rseed) + 16(MAC) bytes.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.NoteCiphertext
 */
export class NoteCiphertext extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.NoteCiphertext";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new NoteCiphertext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoteCiphertext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoteCiphertext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoteCiphertext, a, b);
    }
}
/**
 * The body of an output description, including only the minimal
 * data required to scan and process the output.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.NotePayload
 */
export class NotePayload extends Message {
    /**
     * The note commitment for the output note. 32 bytes.
     *
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment note_commitment = 1;
     */
    noteCommitment;
    /**
     * The encoding of an ephemeral public key. 32 bytes.
     *
     * @generated from field: bytes ephemeral_key = 2;
     */
    ephemeralKey = new Uint8Array(0);
    /**
     * An encryption of the newly created note.
     * 176 = 80(address) + 16(amount) + 32(asset ID) + 32(rseed) + 16(MAC) bytes.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.NoteCiphertext encrypted_note = 3;
     */
    encryptedNote;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.NotePayload";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "note_commitment", kind: "message", T: StateCommitment },
        { no: 2, name: "ephemeral_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "encrypted_note", kind: "message", T: NoteCiphertext },
    ]);
    static fromBinary(bytes, options) {
        return new NotePayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotePayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotePayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotePayload, a, b);
    }
}
/**
 * A Penumbra ZK output proof.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.ZKOutputProof
 */
export class ZKOutputProof extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.ZKOutputProof";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new ZKOutputProof().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ZKOutputProof().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ZKOutputProof().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ZKOutputProof, a, b);
    }
}
/**
 * A Penumbra ZK spend proof.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.ZKSpendProof
 */
export class ZKSpendProof extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.ZKSpendProof";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new ZKSpendProof().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ZKSpendProof().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ZKSpendProof().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ZKSpendProof, a, b);
    }
}
/**
 * A Penumbra ZK nullifier derivation proof.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.ZKNullifierDerivationProof
 */
export class ZKNullifierDerivationProof extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.ZKNullifierDerivationProof";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new ZKNullifierDerivationProof().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ZKNullifierDerivationProof().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ZKNullifierDerivationProof().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ZKNullifierDerivationProof, a, b);
    }
}
/**
 * Spends a shielded note.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.Spend
 */
export class Spend extends Message {
    /**
     * The effecting data of the spend.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.SpendBody body = 1;
     */
    body;
    /**
     * The authorizing signature for the spend.
     *
     * @generated from field: penumbra.crypto.decaf377_rdsa.v1.SpendAuthSignature auth_sig = 2;
     */
    authSig;
    /**
     * The proof that the spend is well-formed is authorizing data.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.ZKSpendProof proof = 3;
     */
    proof;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.Spend";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "body", kind: "message", T: SpendBody },
        { no: 2, name: "auth_sig", kind: "message", T: SpendAuthSignature },
        { no: 3, name: "proof", kind: "message", T: ZKSpendProof },
    ]);
    static fromBinary(bytes, options) {
        return new Spend().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Spend().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Spend().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Spend, a, b);
    }
}
/**
 * ABCI Event recording a spend.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.EventSpend
 */
export class EventSpend extends Message {
    /**
     * @generated from field: penumbra.core.component.sct.v1.Nullifier nullifier = 1;
     */
    nullifier;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.EventSpend";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "nullifier", kind: "message", T: Nullifier },
    ]);
    static fromBinary(bytes, options) {
        return new EventSpend().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventSpend().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventSpend().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventSpend, a, b);
    }
}
/**
 * ABCI Event recording an output.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.EventOutput
 */
export class EventOutput extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment note_commitment = 1;
     */
    noteCommitment;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.EventOutput";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "note_commitment", kind: "message", T: StateCommitment },
    ]);
    static fromBinary(bytes, options) {
        return new EventOutput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventOutput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventOutput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventOutput, a, b);
    }
}
/**
 * ABCI Event recording a clue.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.EventBroadcastClue
 */
export class EventBroadcastClue extends Message {
    /**
     * @generated from field: penumbra.crypto.decaf377_fmd.v1.Clue clue = 1;
     */
    clue;
    /**
     * @generated from field: penumbra.core.txhash.v1.TransactionId tx = 2;
     */
    tx;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.EventBroadcastClue";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "clue", kind: "message", T: Clue },
        { no: 2, name: "tx", kind: "message", T: TransactionId },
    ]);
    static fromBinary(bytes, options) {
        return new EventBroadcastClue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventBroadcastClue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventBroadcastClue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventBroadcastClue, a, b);
    }
}
/**
 * The body of a spend description, containing only the effecting data
 * describing changes to the ledger, and not the authorizing data that allows
 * those changes to be performed.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendBody
 */
export class SpendBody extends Message {
    /**
     * A commitment to the value of the input note.
     *
     * @generated from field: penumbra.core.asset.v1.BalanceCommitment balance_commitment = 1;
     */
    balanceCommitment;
    /**
     * The nullifier of the input note.
     *
     * @generated from field: penumbra.core.component.sct.v1.Nullifier nullifier = 6;
     */
    nullifier;
    /**
     * The randomized validating key for the spend authorization signature.
     *
     * @generated from field: penumbra.crypto.decaf377_rdsa.v1.SpendVerificationKey rk = 4;
     */
    rk;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.SpendBody";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "balance_commitment", kind: "message", T: BalanceCommitment },
        { no: 6, name: "nullifier", kind: "message", T: Nullifier },
        { no: 4, name: "rk", kind: "message", T: SpendVerificationKey },
    ]);
    static fromBinary(bytes, options) {
        return new SpendBody().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpendBody().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpendBody().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpendBody, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendView
 */
export class SpendView extends Message {
    /**
     * @generated from oneof penumbra.core.component.shielded_pool.v1.SpendView.spend_view
     */
    spendView = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.SpendView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "visible", kind: "message", T: SpendView_Visible, oneof: "spend_view" },
        { no: 2, name: "opaque", kind: "message", T: SpendView_Opaque, oneof: "spend_view" },
    ]);
    static fromBinary(bytes, options) {
        return new SpendView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpendView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpendView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpendView, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendView.Visible
 */
export class SpendView_Visible extends Message {
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.Spend spend = 1;
     */
    spend;
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.NoteView note = 2;
     */
    note;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.SpendView.Visible";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "spend", kind: "message", T: Spend },
        { no: 2, name: "note", kind: "message", T: NoteView },
    ]);
    static fromBinary(bytes, options) {
        return new SpendView_Visible().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpendView_Visible().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpendView_Visible().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpendView_Visible, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendView.Opaque
 */
export class SpendView_Opaque extends Message {
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.Spend spend = 1;
     */
    spend;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.SpendView.Opaque";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "spend", kind: "message", T: Spend },
    ]);
    static fromBinary(bytes, options) {
        return new SpendView_Opaque().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpendView_Opaque().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpendView_Opaque().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpendView_Opaque, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.SpendPlan
 */
export class SpendPlan extends Message {
    /**
     * The plaintext note we plan to spend.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.Note note = 1;
     */
    note;
    /**
     * The position of the note we plan to spend.
     *
     * @generated from field: uint64 position = 2;
     */
    position = protoInt64.zero;
    /**
     * The randomizer to use for the spend.
     *
     * @generated from field: bytes randomizer = 3;
     */
    randomizer = new Uint8Array(0);
    /**
     * The blinding factor to use for the value commitment.
     *
     * @generated from field: bytes value_blinding = 4;
     */
    valueBlinding = new Uint8Array(0);
    /**
     * The first blinding factor to use for the ZK spend proof.
     *
     * @generated from field: bytes proof_blinding_r = 5;
     */
    proofBlindingR = new Uint8Array(0);
    /**
     * The second blinding factor to use for the ZK spend proof.
     *
     * @generated from field: bytes proof_blinding_s = 6;
     */
    proofBlindingS = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.SpendPlan";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "note", kind: "message", T: Note },
        { no: 2, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "randomizer", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 4, name: "value_blinding", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 5, name: "proof_blinding_r", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 6, name: "proof_blinding_s", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new SpendPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpendPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpendPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpendPlan, a, b);
    }
}
/**
 * Creates a new shielded note.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.Output
 */
export class Output extends Message {
    /**
     * The effecting data for the output.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.OutputBody body = 1;
     */
    body;
    /**
     * The output proof is authorizing data.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.ZKOutputProof proof = 2;
     */
    proof;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.Output";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "body", kind: "message", T: OutputBody },
        { no: 2, name: "proof", kind: "message", T: ZKOutputProof },
    ]);
    static fromBinary(bytes, options) {
        return new Output().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Output().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Output().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Output, a, b);
    }
}
/**
 * The body of an output description, containing only the effecting data
 * describing changes to the ledger, and not the authorizing data that allows
 * those changes to be performed.
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputBody
 */
export class OutputBody extends Message {
    /**
     * The minimal data required to scan and process the new output note.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.NotePayload note_payload = 1;
     */
    notePayload;
    /**
     * A commitment to the value of the output note. 32 bytes.
     *
     * @generated from field: penumbra.core.asset.v1.BalanceCommitment balance_commitment = 2;
     */
    balanceCommitment;
    /**
     * An encrypted key for decrypting the memo.
     *
     * @generated from field: bytes wrapped_memo_key = 3;
     */
    wrappedMemoKey = new Uint8Array(0);
    /**
     * The key material used for note encryption, wrapped in encryption to the
     * sender's outgoing viewing key. 48 bytes.
     *
     * @generated from field: bytes ovk_wrapped_key = 4;
     */
    ovkWrappedKey = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.OutputBody";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "note_payload", kind: "message", T: NotePayload },
        { no: 2, name: "balance_commitment", kind: "message", T: BalanceCommitment },
        { no: 3, name: "wrapped_memo_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 4, name: "ovk_wrapped_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new OutputBody().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OutputBody().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OutputBody().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OutputBody, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputView
 */
export class OutputView extends Message {
    /**
     * @generated from oneof penumbra.core.component.shielded_pool.v1.OutputView.output_view
     */
    outputView = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.OutputView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "visible", kind: "message", T: OutputView_Visible, oneof: "output_view" },
        { no: 2, name: "opaque", kind: "message", T: OutputView_Opaque, oneof: "output_view" },
    ]);
    static fromBinary(bytes, options) {
        return new OutputView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OutputView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OutputView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OutputView, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputView.Visible
 */
export class OutputView_Visible extends Message {
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.Output output = 1;
     */
    output;
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.NoteView note = 2;
     */
    note;
    /**
     * @generated from field: penumbra.core.keys.v1.PayloadKey payload_key = 3;
     */
    payloadKey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.OutputView.Visible";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "output", kind: "message", T: Output },
        { no: 2, name: "note", kind: "message", T: NoteView },
        { no: 3, name: "payload_key", kind: "message", T: PayloadKey },
    ]);
    static fromBinary(bytes, options) {
        return new OutputView_Visible().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OutputView_Visible().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OutputView_Visible().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OutputView_Visible, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputView.Opaque
 */
export class OutputView_Opaque extends Message {
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.Output output = 1;
     */
    output;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.OutputView.Opaque";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "output", kind: "message", T: Output },
    ]);
    static fromBinary(bytes, options) {
        return new OutputView_Opaque().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OutputView_Opaque().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OutputView_Opaque().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OutputView_Opaque, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.OutputPlan
 */
export class OutputPlan extends Message {
    /**
     * The value to send to this output.
     *
     * @generated from field: penumbra.core.asset.v1.Value value = 1;
     */
    value;
    /**
     * The destination address to send it to.
     *
     * @generated from field: penumbra.core.keys.v1.Address dest_address = 2;
     */
    destAddress;
    /**
     * The rseed to use for the new note.
     *
     * @generated from field: bytes rseed = 3;
     */
    rseed = new Uint8Array(0);
    /**
     * The blinding factor to use for the value commitment.
     *
     * @generated from field: bytes value_blinding = 4;
     */
    valueBlinding = new Uint8Array(0);
    /**
     * The first blinding factor to use for the ZK output proof.
     *
     * @generated from field: bytes proof_blinding_r = 5;
     */
    proofBlindingR = new Uint8Array(0);
    /**
     * The second blinding factor to use for the ZK output proof.
     *
     * @generated from field: bytes proof_blinding_s = 6;
     */
    proofBlindingS = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.OutputPlan";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "message", T: Value },
        { no: 2, name: "dest_address", kind: "message", T: Address },
        { no: 3, name: "rseed", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 4, name: "value_blinding", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 5, name: "proof_blinding_r", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 6, name: "proof_blinding_s", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new OutputPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OutputPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OutputPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OutputPlan, a, b);
    }
}
/**
 * Requests information on an asset by asset id
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.AssetMetadataByIdRequest
 */
export class AssetMetadataByIdRequest extends Message {
    /**
     * The asset id to request information on.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId asset_id = 2;
     */
    assetId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.AssetMetadataByIdRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "asset_id", kind: "message", T: AssetId },
    ]);
    static fromBinary(bytes, options) {
        return new AssetMetadataByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssetMetadataByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssetMetadataByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssetMetadataByIdRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.AssetMetadataByIdResponse
 */
export class AssetMetadataByIdResponse extends Message {
    /**
     * If present, information on the requested asset.
     *
     * If the requested asset was unknown, this field will not be present.
     *
     * @generated from field: penumbra.core.asset.v1.Metadata denom_metadata = 1;
     */
    denomMetadata;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.AssetMetadataByIdResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "denom_metadata", kind: "message", T: Metadata },
    ]);
    static fromBinary(bytes, options) {
        return new AssetMetadataByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssetMetadataByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssetMetadataByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssetMetadataByIdResponse, a, b);
    }
}
/**
 * Requests information on an asset by multiple asset ids
 *
 * @generated from message penumbra.core.component.shielded_pool.v1.AssetMetadataByIdsRequest
 */
export class AssetMetadataByIdsRequest extends Message {
    /**
     * The asset IDs to request information on. Note that node is neither required
     * nor expected to stream responses in the same order as this array.
     *
     * @generated from field: repeated penumbra.core.asset.v1.AssetId asset_id = 1;
     */
    assetId = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.AssetMetadataByIdsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "asset_id", kind: "message", T: AssetId, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AssetMetadataByIdsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssetMetadataByIdsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssetMetadataByIdsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssetMetadataByIdsRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.shielded_pool.v1.AssetMetadataByIdsResponse
 */
export class AssetMetadataByIdsResponse extends Message {
    /**
     * A single asset metadata streamed from the node.
     *
     * @generated from field: penumbra.core.asset.v1.Metadata denom_metadata = 1;
     */
    denomMetadata;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.shielded_pool.v1.AssetMetadataByIdsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "denom_metadata", kind: "message", T: Metadata },
    ]);
    static fromBinary(bytes, options) {
        return new AssetMetadataByIdsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssetMetadataByIdsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssetMetadataByIdsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssetMetadataByIdsResponse, a, b);
    }
}
